import axiosConfig from "../Service/axiosConfig";

export const checkSession = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
        return false;
    }
    try {
        await axiosConfig.get("/user_data/check-session/");
        return true;
    } catch (error) {
        const status = error.response?.status;
        if (status === 401 || status === 403) {
            localStorage.removeItem("token")
            localStorage.removeItem('userId');
            localStorage.removeItem('number');
            localStorage.removeItem('address_id');
            localStorage.removeItem('traveltime');
            localStorage.removeItem('wishlists');
            localStorage.removeItem('total');
            localStorage.removeItem('orderId');
            return false;
        }
    }
};